export const categoryConstants = {
    GET_CATEGORIES_SUCCESS:  'GET_CATEGORY_SUCCESS',
    SHOW_CATEGORY_SUCCESS: 'SHOW_CATEGORY_SUCCESS',
    UPDATE_CATEGORY_SUCCESS: 'UPDATE_CATEGORY_SUCCESS',
    ADD_CATEGORY_SUCCESS: 'ADD_CATEGORY_SUCCESS',
    REMOVE_CATEGORY_SUCCESS: 'REMOVE_CATEGORY_SUCCESS',
    STORE_CATEGORY_SUCCESS: 'STORE_CATEGORY_SUCCESS',
};